export default Object.freeze({
  //QORANI_BACKEND_SERVICES: "http://localhost:8083/",
  QORANI: "https://qorani-qorani-backend.gbapgy.easypanel.host/",
});
